export default async function FetchImages(l, m) {
  const imageAdd = require(`../../files/${l.imgUrl}`);

  m.push(imageAdd);

  return m;
}
